import { render, staticRenderFns } from "./DeliveryUnit.vue?vue&type=template&id=6bf13a81&"
import script from "./DeliveryUnit.vue?vue&type=script&lang=js&"
export * from "./DeliveryUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports